import { useSelector } from 'react-redux';

import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { trackInsight } from '@framework/appInsights';
import { ServerStateKeys } from '@framework/constants/serverStateKeys';

import { getCurrentAppSection, getIsAttendeeView } from '@redux/selectors/AppSelector';

import type { Member } from '@type/members';
import type { Room } from '@type/rooms';

const useSendInsight = () => {
    const router = useRouter();
    const queryClient = useQueryClient();

    const activeRoom = queryClient.getQueryData<Room>([ServerStateKeys.Room, router.query.room]);
    const member = queryClient.getQueryData<Member>([
        ServerStateKeys.Member,
        { id: activeRoom?.memberUuid }
    ]);
    const currentAppSection = useSelector(getCurrentAppSection);
    const isAttendeeView = useSelector(getIsAttendeeView);

    const sendInsight = (insightName: string, data?: { [key: string]: unknown }) => {
        return trackInsight(
            insightName,
            {
                ...data,
                organisationId: activeRoom?.organisation?.id,
                organisationName: activeRoom?.organisation?.name,
                roomId: activeRoom?.id,
                userId: member?.user?.id,
                isSherpany: member?.user?.isSherpanyUser,
                language: member?.user?.language,
                roomType: activeRoom?.type
            },
            {
                currentAppSection,
                isAttendeeView,
                activeRoom,
                loggedMember: member?.user
            }
        );
    };

    return sendInsight;
};

export default useSendInsight;
